import { FaCalendar } from 'src/shared/design-system/FontAwesome';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { BoxShadow, Colors, Font, Mixins, ScreenWidth, Spacing, Transition } from 'web-common/src/shared/styles';

const LARGE_DAY_SIZE = '44px';
const SMALL_DAY_SIZE = '40px';

export const CalendarIcon = () => <FaCalendar />;

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  margin-right: -${Spacing.TRIPLE};
  width: ${Spacing.TRIPLE};
  pointer-events: none;
  z-index: 1;
`;

export const InputContainer = styled.div<{ light?: boolean }>`
  display: flex;

  & .react-datepicker-wrapper > .react-datepicker__input-container > input {
    height: auto;
    padding-left: calc(${Spacing.DOUBLE} + ${Spacing.THREE_QUARTERS}) !important;
    box-sizing: border-box;

    ${ifProp(
      'light',
      css`
        ${Mixins.Input.TextLightStyles}
      `,
      css`
        ${Mixins.Input.TextStyles}
      `
    )}
  }
`;

export const Label = styled.label`
  align-items: center;
  display: flex !important;
  gap: ${Spacing.HALF};
  margin-top: ${Spacing.HALF};
`;

export const RequiredText = styled.span`
  color: ${Colors.RADISH};
  font-size: ${Font.Size.M};
`;

export const Container = styled.div`
  & .react-datepicker {
    border: 1px solid ${Colors.GRAY};
    border-radius: 0;
    box-shadow: ${BoxShadow.MENU};
    font-family: ${Font.Family.SANS};
    font-size: ${Font.Size.S};
    font-weight: 400;

    .react-datepicker__month-container {
      .react-datepicker__header {
        background: ${Colors.GRAY_LITE_30};
        border-bottom: none;
        padding-top: ${Spacing.SINGLE};

        .react-datepicker__current-month {
          font-size: ${Font.Size.M};
          font-weight: 600;
          padding-bottom: ${Spacing.HALF};
        }
        .react-datepicker__day-names {
          display: flex;
          justify-content: center;

          .react-datepicker__day-name {
            align-items: center;
            display: inline-flex;
            justify-content: center;
            line-height: 1;
            margin: 0;
            padding: 0;
            height: ${LARGE_DAY_SIZE};
            width: ${LARGE_DAY_SIZE};

            @media (max-width: ${ScreenWidth.SMALL}) {
              height: ${SMALL_DAY_SIZE};
              width: ${SMALL_DAY_SIZE};
            }
          }
        }
      }
      .react-datepicker__month {
        margin: ${Spacing.THREE_QUARTERS};

        @media (max-width: ${ScreenWidth.SMALL}) {
          margin: ${Spacing.HALF};
        }

        .react-datepicker__week {
          display: flex;
          justify-content: center;

          .react-datepicker__day {
            align-items: center;
            border-radius: ${LARGE_DAY_SIZE};
            color: ${Colors.GRAY_DARK_30};
            display: inline-flex;
            justify-content: center;
            line-height: 1;
            margin: 0;
            padding: 0;
            height: ${LARGE_DAY_SIZE};
            width: ${LARGE_DAY_SIZE};
            transition: background ${Transition.Time.BASE};

            @media (max-width: ${ScreenWidth.SMALL}) {
              border-radius: ${SMALL_DAY_SIZE};
              height: ${SMALL_DAY_SIZE};
              width: ${SMALL_DAY_SIZE};
            }
            &.react-datepicker__day--keyboard-selected {
              background-color: ${Colors.WHITE};
            }
            &.react-datepicker__day--selected,
            &.react-datepicker__day--in-selecting-range,
            &.react-datepicker__day--in-range {
              background-color: ${Colors.RADISH};
              color: ${Colors.WHITE};
            }
            &.react-datepicker__day--outside-month,
            &.react-datepicker__day--disabled {
              color: ${Colors.GRAY};
            }
          }
        }
      }
    }
    .react-datepicker__navigation {
      border: none;
      height: 20px;
      outline: none;
      overflow: visible;
      top: ${Spacing.QUARTER};
      height: ${LARGE_DAY_SIZE};
      width: ${LARGE_DAY_SIZE};

      @media (max-width: ${ScreenWidth.SMALL}) {
        height: ${SMALL_DAY_SIZE};
        width: ${SMALL_DAY_SIZE};
      }

      & .react-datepicker__navigation-icon:before {
        height: ${Spacing.SINGLE};
        width: ${Spacing.SINGLE};
        transition: border ${Transition.Time.BASE};
      }

      &:hover .react-datepicker__navigation-icon:before {
        border-color: ${Colors.GRAY_DARK_10};
      }

      &:active .react-datepicker__navigation-icon:before {
        border-color: ${Colors.GRAY_DARK_30};
      }

      &.react-datepicker__navigation--previous {
        left: 0;

        & .react-datepicker__navigation-icon {
          right: 0;

          &:before {
            right: -${Spacing.THREE_QUARTERS};
            top: ${Spacing.HALF};
          }
        }
      }

      &.react-datepicker__navigation--next {
        right: 0;

        & .react-datepicker__navigation-icon {
          left: 0;

          &:before {
            left: -${Spacing.THREE_QUARTERS};
            top: ${Spacing.HALF};
          }
        }
      }
    }
  }
  .react-datepicker__close-icon::after {
    background-color: ${Colors.AQUA};
  }
  .react-datepicker-popper {
    z-index: 9;
  }
  & .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    left: -60px !important;

    &::after {
      border-bottom-color: ${Colors.GRAY_LITE_30};
    }
  }
`;
